import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react";
import { Container, Row, Col} from 'react-bootstrap';
import Header from 'Components/Header/Header'
import Footer from 'Components/Footer/Footer'
import Genresmenu from 'Components/Genresmenu/Genresmenu'
import Resetfilter from 'Components/Resetfilter/Resetfilter'
import Searchinp from 'Components/Searchinp/Searchinp'
import Weeksmenu from 'Components/Weeksmenu/Weeksmenu'
import Slider from 'Components/Slider/Slider'
import Clipsarea from 'Components/Clipsarea/Clipsarea'
import Channelsmenu from 'Components/Channelsmenu/Channelsmenu'
import Singleview from 'Components/Singleview/Singleview'
import Userdata from 'Components/Userdata/Userdata'
import Mentionslegal from 'Components/Mentionslegal/Mentionslegal'
import './Page.css';


//Page ist die Mutter aller Komponenten: 


const Page = observer(
  class Page extends Component {
	
		state = {actclip:false,showudata:false,showmentionslegal:false};
		
		selectClip = (id) => {
			let actcl = false;
			let clips = this.props.searchres.objects.asArray();
			for(var cl of clips) {
				if(cl.getId() == id) 
					actcl = cl;
			}
			if(!actcl) {
				let clips = this.props.carouselclips;
				for(var cl of clips) {
					if(cl.clip.getId() == id) 
						actcl = cl.clip;
				}
			}
			this.setState({actclip:actcl});
		}
			
		componentDidMount = () => {
			if(typeof(this.props.loadprofile) != 'undefined') {//das wird nur gesetzt, wenn man den link zum profiloeffnen beutzt
				this.setState({showudata:this.props.loadprofile});
			}
			if(typeof(this.props.hidemenleg) != 'undefined') {
				this.setState({showmentionslegal:false});
			}
		}
	
		closeUdata = () => {
			this.setState({showudata:false});
		}	
		openUdata = () => {
			this.setState({showudata:true});
		}
		openMentionslegal = () => {
			this.setState({showmentionslegal:true});
		}
			
		setcrits = () => {

		}
			
    render() {
			let newchains = [].concat(this.props.skchains);
			let newgenres = [].concat(this.props.skgenres);
			let newstatis = [].concat(this.props.skstatis);
			let newweeks = [].concat(this.props.skweeks);
			if(this.state.showudata) {
				return (<Userdata updusercb={this.props.updusercb} closecb={this.closeUdata} user={this.props.user}/>)
			}
			return  (
				<Container fluid>
					<Container fluid="lg"><Header  user={this.props.user} openudata={this.openUdata}/></Container>
					{this.state.actclip == false && (
						<Container fluid="lg">
							<Channelsmenu setcritcb={this.props.setcritcb} skchains={newchains} skstatis={newstatis} user={this.props.user}/>
							<Row>
								<Searchinp fulltextterm={this.props.fulltextterm} setcritcb={this.props.setcritcb} />
							</Row>
							<Row className="mb30">
								<Col xs={4} md={3} lg={2}>
									<Weeksmenu  setcritcb={this.props.setcritcb} skweeks={newweeks} />
									<Genresmenu setcritcb={this.props.setcritcb} skgenres={newgenres}  user={this.props.user}/>
									<Resetfilter setcritcb={this.props.setcritcb} />
								</Col>
								<Col xs={8} md={9} lg={10}>
									{this.props.showmenleg != false && (
										<Mentionslegal />
									)}
									{this.props.showmenleg == false && (
										<>
										<Slider clipclickcb={this.selectClip}  carouselclips={this.props.carouselclips}  />
										<Clipsarea clipclickcb={this.selectClip}  setcritcb={this.props.setcritcb} searchres={this.props.searchres} />
										</>
									)}
								</Col>
							</Row>
						</Container>
					)}
					{this.state.actclip != false && (
						<Singleview clipclickcb={this.selectClip} clip={this.state.actclip} />
					)}
					<Footer openmenleg={this.props.showmenlegcb} />
				</Container>
			)
    }
		
  }
)


export default Flow.injectFlow(Page);